import React from "react";
import PageNotFoundContent from "../components/PageNotFoundContent/PageNotFoundContent";
import DefaultLayout from "../layouts/DefaultLayout";

const PageNotFound = () => {
  return (
    <DefaultLayout>
      <PageNotFoundContent />
    </DefaultLayout>
  );
};

export default PageNotFound;
